export default __webpack_public_path__ + "static/media/sketching4.42a9b858.jpg";